import React from 'react'

function ThinLine() {
  return (
    <div className='w-32 h-px bg-gray'></div>
  )
}

export default ThinLine